import { ISurvey } from '../typing'

export type ISurveyContext = ISurvey

export type Action = {
  type: 'LOAD_INITIAL_SURVEY'
  payload: ISurvey
}

const surveyReducer = (
  state: ISurveyContext,
  { type, payload }: Action
): ISurveyContext => {
  switch (type) {
    case 'LOAD_INITIAL_SURVEY':
      return {
        ...payload,
      }

    default:
      return state
  }
}

export default surveyReducer
